import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';
import { DateAdapter } from '@angular/material/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericEntryForm } from 'src/app/infrastructure/infrastructure-services/generics/genericentryform/generic-entry-form';
import { ExchangeRateModel, ExchangeRateModelSAP, IExchangeRateModel, IExchangeRateModelSAP } from 'src/app/core/models/masters/exchangerate-master.model';

@Component({
  selector: 'app-update-exchange-rate',
  templateUrl: './update-exchange-rate.component.html',
  styles: []
})
export class UpdateExchangeRateComponent extends GenericEntryForm<IExchangeRateModel, IExchangeRateModelSAP>  {

  displayedColumns: string[] = ['currency', 'update_new_rate'];
  dataSource: any = [];
  startDate: any
  endDate: any
  local_data: any;
  updatedData: any = [];
  constructor(agenericRepository: GenericService<IExchangeRateModel>,
    public dialogRef: MatDialogRef<UpdateExchangeRateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    dialog: MatDialog, router: Router, private dateAdapter: DateAdapter<Date>,) {
    super(agenericRepository, router, dialog);
    this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
    this.local_data = { ...data };
   
    // this.local_data.displayCol.forEach((element:any, index:number) => {
    //     if (element == "Date") {
    //       this.local_data.displayCol.splice(index, 1);
    //     }
        
    //   });
    // console.log(this.local_data)
    // this.updatedData = this.local_data.displayCol;
    // this.updatedData.forEach((element:any, index:number) => {
    //   if (element == "Date") {
    //     this.updatedData.splice(index, 1);
    //   }
    //   console.log(this.updatedData)
    // });


  }

  onSave() {

    this.dialogRef.close({
      event: true, data: this.local_data.updateColData, startDate: this.local_data.FromDate, endDate: this.local_data.ToDate
    });
  }
  updateColData(item: any, event: any) {
    var obj = {
      column: item,
      value: event.target.value
    }
    this.local_data.updateColData.push(obj);
  }


}
